import React from "react";
import { formatRupiah } from "../utils/FormattedPrice";
import { getProductBarcode, Product } from "../types/product";

interface DetailProductProps {
  onGenerateBarcode: (product: Product) => void;
  isLoading: boolean;
  handleRemoveItem: (index: string) => void;
  onSelectSerialNumber?: (product: Product) => void;
  lists: Product[];
  onUpdateProduct: (index: number, field: string, value: any) => void;
}

const DetailProduct: React.FC<DetailProductProps> = ({
  onGenerateBarcode,
  handleRemoveItem,
  onSelectSerialNumber,
  isLoading,
  lists,
  onUpdateProduct,
}) => {
  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-sm text-left rtl:text-right text-gray-500">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50">
          <tr>
            <th scope="col" className="px-6 py-3 max-w-[100px]">
              Product Code
            </th>
            <th scope="col" className="px-6 py-3 max-w-[200px]">
              Product Name
            </th>
            <th scope="col" className="px-6 py-3">
              Price
            </th>
            <th scope="col" className="px-6 py-3">
              Barcode Number
            </th>
            <th scope="col" className="px-6 py-3">
              Print Quantity
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {lists?.map((item: Product, index: number) => (
            <tr
              className="bg-white border-b"
              key={`${item.itemNumber}-${item.serialNumber ?? "base"}`}
            >
              <td className="px-6 py-4 font-medium text-gray-900 max-w-[100px] truncate">
                {item?.itemNumber ?? "-"}
              </td>
              <td className="px-6 py-4 font-medium text-gray-900 max-w-[200px] truncate">
                {item?.itemName ?? "-"}
              </td>
              <td className="px-6 py-4">
                {formatRupiah(item?.itemPrice ?? 0)}
              </td>
              <td className="px-6 py-4">
                <div className="flex items-center gap-4">
                  {getProductBarcode(item) ? (
                    <span>{getProductBarcode(item)}</span>
                  ) : (
                    <button
                      onClick={() => {
                        onGenerateBarcode(item);
                      }}
                      disabled={isLoading}
                      className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                    >
                      {isLoading ? "Generating..." : "Generate Barcode"}
                    </button>
                  )}
                  {item.hasSerialNumber &&
                    !item.serialNumber &&
                    onSelectSerialNumber && (
                    <button
                      onClick={() => onSelectSerialNumber(item)}
                      disabled={isLoading}
                      className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                    >
                      Pilih Serial Number
                    </button>
                  )}
                </div>
              </td>
              <td className="px-6 py-4">
                <div className="flex items-center gap-4">
                  <input
                    type="text"
                    name="printQty"
                    min={0}
                    value={item.printQty || ""}
                    placeholder="Print Quantity"
                    className="w-full border p-2 rounded"
                    pattern="[0-9]*"
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "" || /^\d+$/.test(val)) {
                        onUpdateProduct(
                          index,
                          "printQty",
                          val === "" ? undefined : Number(val)
                        );
                      }
                    }}
                  />
                </div>
              </td>
              <td>
                <button
                  onClick={() => handleRemoveItem(String(index))}
                  disabled={isLoading}
                  className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DetailProduct;
